<template>
  <table v-if="manager" class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
    <thead class="p-datatable-thead">
      <tr class="table-opened-info__header-row">
        <th>{{ manager.name }}</th>
        <th style="width: 20%">{{ $t('Count') }}</th>
        <th style="width: 20%">{{ $t('Percent') }}</th>
      </tr>
    </thead>
    <tbody class="p-datatable-tbody">
      <tr v-if="hasQty(manager.wrong_qty)">
        <td>{{ reducedReasonLabel(1) }}</td>
        <td>{{ manager.wrong_qty }}</td>
        <td>{{ calculatePercent(manager.wrong_qty) }}%</td>
      </tr>
      <tr v-if="manager.mistake_qty">
        <td>{{ reducedReasonLabel(2) }}</td>
        <td>{{ manager.mistake_qty }}</td>
        <td>{{ calculatePercent(manager.mistake_qty) }}%</td>
      </tr>
      <tr v-if="manager.customer_refused_qty">
        <td>{{ reducedReasonLabel(3) }}</td>
        <td>{{ manager.customer_refused_qty }}</td>
        <td>{{ calculatePercent(manager.customer_refused_qty) }}%</td>
      </tr>
      <tr v-if="manager.customer_did_not_come_qty">
        <td>{{ reducedReasonLabel(4) }}</td>
        <td>{{ manager.customer_did_not_come_qty }}</td>
        <td>{{ calculatePercent(manager.customer_did_not_come_qty) }}%</td>
      </tr>
      <tr v-if="manager.warranty_qty">
        <td>{{ reducedReasonLabel(5) }}</td>
        <td>{{ manager.warranty_qty }}</td>
        <td>{{ calculatePercent(manager.warranty_qty) }}%</td>
      </tr>
      <tr v-if="manager.defective_qty">
        <td>{{ reducedReasonLabel(6) }}</td>
        <td>{{ manager.defective_qty }}</td>
        <td>{{ calculatePercent(manager.defective_qty) }}%</td>
      </tr>
      <tr v-if="manager.old_part_qty">
        <td>{{ reducedReasonLabel(7) }}</td>
        <td>{{ manager.old_part_qty }}</td>
        <td>{{ calculatePercent(manager.old_part_qty) }}%</td>
      </tr>
      <tr v-if="manager.other_qty">
        <td>{{ reducedReasonLabel(9) }}</td>
        <td>{{ manager.other_qty }}</td>
        <td>{{ calculatePercent(manager.other_qty) }}%</td>
      </tr>
      <tr class="table-opened-info__row--total">
        <td class="no-bottom-border">{{ $t('Total') }}</td>
        <td class="no-bottom-border">{{ calculateCount(manager) }} / {{ Number(manager.ordered_qty || 0) }}</td>
        <td class="no-bottom-border">{{ calculatePercent(calculateCount(manager)) }}%</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";
import ReducedPositionReasons from "@/translations/ReducedPositionReasons";

export default {
  mixins: [ formatMixins ],
  name: 'ReturnsPanelTable',
  props: {
    manager: {
      type: Object,
      default: null
    },
  },
  data: () => {
    return {
      ReducedPositionReasons,
    }
  },
  methods: {
    hasQty(value) {
      return Number(value || 0) > 0
    },
    reducedReasonLabel(id) {
      const reason = this.ReducedPositionReasons.find(reason => Number(reason.id) === Number(id))

      return reason?.label?.[this.$i18n.locale] || reason?.label?.en || ''
    },
    calculatePercent(qty) {
      const orderedQty = Number(this.manager?.ordered_qty || 0)
      const value = Number(qty || 0)

      if (!orderedQty || !value) return 0

      return this.formatDecimal(value * 100 / orderedQty)
    },
    calculateCount(manager) {
      if (!manager) return 0
      const wrong_qty = manager.wrong_qty ?? 0
      const mistake_qty = manager.mistake_qty ?? 0
      const customer_refused_qty = manager.customer_refused_qty ?? 0
      const customer_did_not_come_qty = manager.customer_did_not_come_qty ?? 0
      const warranty_qty = manager.warranty_qty ?? 0
      const defective_qty = manager.defective_qty ?? 0
      const old_part_qty = manager.old_part_qty ?? 0
      const other_qty = manager.other_qty ?? 0

      return +wrong_qty + +mistake_qty + +customer_refused_qty + +customer_did_not_come_qty + +warranty_qty + +defective_qty + +old_part_qty + +other_qty
    },
  }
}
</script>